export const CORE_VALUES = [
  { key: 'respect', icon: 'Heart' },
  { key: 'gratitude', icon: 'Sparkles' },
  { key: 'loyalty', icon: 'Shield' },
  { key: 'integrity', icon: 'Shield' },
  { key: 'trust', icon: 'Users' },
  { key: 'responsibility', icon: 'Target' },
  { key: 'cooperation', icon: 'Users' },
]

export const ACCREDITATION_LOGOS = [
  { name: 'Cognia', slug: 'cognia', image: '/logo/accreditations/cognia.png' },
  { name: 'Accreditation International (Ai)', slug: 'ai', image: '/logo/accreditations/ai.png' },
  { name: 'NCPSA', slug: 'ncpsa', image: '/logo/accreditations/ncpsa.png' },
  { name: 'Cambridge Assessment International Education', slug: 'cambridge', image: '/logo/accreditations/cambridge.png' },
  { name: 'Pearson Edexcel', slug: 'edexcel', image: '/logo/accreditations/edexcel.png' },
  { name: 'Oxford International AQA Examinations', slug: 'oxford', image: '/logo/accreditations/oxford.png' },
  { name: 'TÜV Austria Hellas — EN ISO 9001:2015', slug: 'iso', image: '/logo/accreditations/iso.png' },
  { name: 'British Council Partner School', slug: 'british-council', image: '/logo/accreditations/british-council.png' },
]

export const PARTNER_LOGOS = [
  { name: 'Cognia', slug: 'cognia', image: '/logo/accreditations/cognia.png' },
  { name: 'Cambridge Assessment International Education', slug: 'cambridge', image: '/logo/accreditations/cambridge.png' },
  { name: 'Pearson Edexcel', slug: 'edexcel', image: '/logo/accreditations/edexcel.png' },
  { name: 'Oxford International AQA Examinations', slug: 'oxford', image: '/logo/accreditations/oxford.png' },
  { name: 'British Council Partner School', slug: 'british-council', image: '/logo/accreditations/british-council.png' },
]

export const VALUES_CAROUSEL = [
  { value: 'respect', image: '/slider/001.JPG' },
  { value: 'integrity', image: '/slider/002.JPG' },
  { value: 'responsibility', image: '/slider/003.JPG' },
  { value: 'trust', image: '/slider/004.JPG' },
  { value: 'cooperation', image: '/slider/001.JPG' },
  { value: 'gratitude', image: '/slider/002.JPG' },
  { value: 'loyalty', image: '/slider/003.JPG' },
]

export const BEYOND_CLASSROOM_SLIDES = [
  { key: 'sports', image: '/slider/002.JPG', link: '/pages/BeyondClassroom' },
  { key: 'arts', image: '/slider/1998.jpg', link: '/pages/BeyondClassroom' },
  { key: 'leadership', image: '/slider/001.JPG', link: '/pages/Leadership' },
  { key: 'robotics', image: '/slider/004.JPG', link: '/pages/BeyondClassroom' },
]

export const REAL_WORLD_PROGRAMS = [
  { key: 'ai', image: '/slider/004.JPG' },
  { key: 'entrepreneurship', image: '/slider/001.JPG' },
  { key: 'arabic', image: '/slider/002.JPG' },
  { key: 'environment', image: '/slider/003.JPG' },
  { key: 'media', image: '/slider/004.JPG' },
  { key: 'community', image: '/slider/001.JPG' },
]

export const PARENT_TESTIMONIALS = [
  { key: 'british1', image: '/slider/001.JPG', program: 'british' },
  { key: 'american', image: '/slider/002.JPG', program: 'american' },
  { key: 'national', image: '/slider/003.JPG', program: 'national' },
  { key: 'british2', image: '/slider/004.JPG', program: 'british' },
  { key: 'british3', image: '/slider/001.JPG', program: 'british' },
]

export const ALUMNI_STORIES = [
  { key: 'mit', image: '/slider/001.JPG', program: 'british' },
  { key: 'toronto', image: '/slider/002.JPG', program: 'american' },
  { key: 'jordan', image: '/slider/003.JPG', program: 'national' },
  { key: 'manchester', image: '/slider/004.JPG', program: 'british' },
  { key: 'psut', image: '/slider/001.JPG', program: 'national' },
  { key: 'mcgill', image: '/slider/002.JPG', program: 'american' },
]

export const STUDENT_EXPERIENCES = [
  { key: 'reading', image: '/slider/001.JPG', program: 'british' },
  { key: 'science', image: '/slider/002.JPG', program: 'american' },
  { key: 'math', image: '/slider/003.JPG', program: 'national' },
  { key: 'robotics', image: '/slider/004.JPG', program: 'british' },
  { key: 'mun', image: '/slider/001.JPG', program: 'american' },
  { key: 'activities', image: '/slider/002.JPG', program: 'national' },
]

export const POTENTIAL_SLIDES = [
  { key: 'epq', image: '/slider/001.JPG', program: 'british' },
  { key: 'ap', image: '/slider/002.JPG', program: 'american' },
  { key: 'robotics', image: '/slider/004.JPG', program: 'stem' },
  { key: 'arabic', image: '/slider/003.JPG', program: 'national' },
  { key: 'mun', image: '/slider/001.JPG', program: 'leadership' },
]

export const SCHOOLS = [
  {
    id: 'MisTlaAlAli',
    slug: 'MisTlaAlAli',
    country: 'Jordan',
    city: 'Amman',
    area: 'Tla Al-Ali',
    curricula: ['national', 'british', 'american'],
    ages: 'K-12',
    mapUrl: 'https://maps.google.com/?q=Mayar+International+Schools+Tla+Al-Ali+Amman',
  },
  {
    id: 'MisKhalda',
    slug: 'MisKhalda',
    country: 'Jordan',
    city: 'Amman',
    area: 'Khalda',
    curricula: ['national', 'american'],
    ages: 'K-6',
    mapUrl: 'https://maps.google.com/?q=Mayar+International+Schools+Khalda+Amman',
  },
]

export const UNIVERSITY_DESTINATIONS = [
  {
    regionKey: 'uk',
    countryCode: 'GB',
    universities: [
      { name: 'University of Bristol', city: 'Bristol, England, United Kingdom' },
      { name: 'University of Bedfordshire', city: 'Luton, England, United Kingdom' },
      { name: 'University of Leeds', city: 'Leeds, England, United Kingdom' },
      { name: 'University of Plymouth', city: 'Plymouth, England, United Kingdom' },
      { name: 'University of Manchester', city: 'Manchester, England, United Kingdom' },
      { name: 'Nottingham Trent University', city: 'Nottingham, England, United Kingdom' },
    ],
  },
  {
    regionKey: 'canada',
    countryCode: 'CA',
    universities: [
      { name: 'University of Calgary', city: 'Calgary, Alberta, Canada' },
      { name: 'Carleton University', city: 'Ottawa, Ontario, Canada' },
      { name: 'McMaster University', city: 'Hamilton, Ontario, Canada' },
      { name: 'University of Toronto', city: 'Toronto, Ontario, Canada' },
      { name: 'University of British Columbia', city: 'Vancouver, British Columbia, Canada' },
    ],
  },
  {
    regionKey: 'us',
    countryCode: 'US',
    universities: [
      { name: 'Collin College', city: 'McKinney, Texas, United States' },
      { name: 'Indiana University Bloomington', city: 'Bloomington, Indiana, United States' },
      { name: 'Arizona State University', city: 'Tempe, Arizona, United States' },
      { name: 'University of Texas at Dallas', city: 'Richardson, Texas, United States' },
      { name: 'University of Nebraska', city: 'Lincoln, Nebraska, United States' },
      { name: 'Georgia Institute of Technology', city: 'Atlanta, Georgia, United States' },
      { name: 'University of South Florida', city: 'Tampa, Florida, United States' },
    ],
  },
  {
    regionKey: 'australia',
    countryCode: 'AU',
    universities: [
      { name: 'Macquarie University', city: 'Sydney, New South Wales, Australia' },
      { name: 'La Trobe University', city: 'Melbourne, Victoria, Australia' },
    ],
  },
  {
    regionKey: 'ireland',
    countryCode: 'IE',
    universities: [{ name: 'University of Galway', city: 'Galway, Ireland' }],
  },
  {
    regionKey: 'italy',
    countryCode: 'IT',
    universities: [{ name: 'University of Rome Tor Vergata', city: 'Rome, Italy' }],
  },
  {
    regionKey: 'hungary',
    countryCode: 'HU',
    universities: [{ name: 'University of Debrecen', city: 'Debrecen, Hungary' }],
  },
  {
    regionKey: 'romania',
    countryCode: 'RO',
    universities: [{ name: 'University of Bucharest', city: 'Bucharest, Romania' }],
  },
  {
    regionKey: 'georgia',
    countryCode: 'GE',
    universities: [
      { name: 'Georgian National University SEU', city: 'Tbilisi, Georgia' },
      { name: 'Ivane Javakhishvili Tbilisi State University', city: 'Tbilisi, Georgia' },
    ],
  },
  {
    regionKey: 'malaysia',
    countryCode: 'MY',
    universities: [{ name: 'Universiti Kuala Lumpur', city: 'Kuala Lumpur, Malaysia' }],
  },
  {
    regionKey: 'cyprus',
    countryCode: 'CY',
    universities: [{ name: 'Frederick University', city: 'Nicosia, Cyprus' }],
  },
  {
    regionKey: 'uae',
    countryCode: 'AE',
    universities: [{ name: 'American University of Sharjah', city: 'Sharjah, United Arab Emirates' }],
  },
  {
    regionKey: 'malta',
    countryCode: 'MT',
    universities: [{ name: 'American University of Malta', city: 'Cospicua, Malta' }],
  },
  {
    regionKey: 'egypt',
    countryCode: 'EG',
    universities: [
      { name: 'Assiut University', city: 'Assiut, Egypt' },
      { name: 'Alexandria University', city: 'Alexandria, Egypt' },
      { name: 'Cairo University', city: 'Giza, Egypt' },
      { name: 'Ain Shams University', city: 'Cairo, Egypt' },
    ],
  },
  {
    regionKey: 'saudi',
    countryCode: 'SA',
    universities: [{ name: 'Alfaisal University', city: 'Riyadh, Saudi Arabia' }],
  },
  {
    regionKey: 'iraq',
    countryCode: 'IQ',
    universities: [
      { name: 'Al-Mashriq University', city: 'Baghdad, Iraq' },
      { name: 'Uruk University', city: 'Baghdad, Iraq' },
      { name: 'University of Baghdad', city: 'Baghdad, Iraq' },
    ],
  },
  {
    regionKey: 'algeria',
    countryCode: 'DZ',
    universities: [{ name: 'University of Blida 1', city: 'Blida, Algeria' }],
  },
]

export const MIS_KHALDA_GALLERY = Array.from({ length: 10 }, (_, index) => ({
  src: `/pages/mis-khalda/${String(index + 1).padStart(2, '0')}.jpg`,
  alt: `Mayar International Schools 2 — Khalda ${index + 1}`,
}))

export { PROGRAM_PAGES } from '../constants/pageSlugs'

export const APP_LINKS = {
  ios: 'https://apps.apple.com/gb/app/mayar-international-schools/id1209836912',
  android: 'https://play.google.com/store/apps/details?id=ac.mayarschools&pli=1',
}
